module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/TemperatureMax/Nagano_TemperatureMax_MRI_RCP85_End.png";